import {DomainEvent} from './DomainEvent';
import {MatchVideoEmbedding} from '../resources/MatchVideoEmbedding';

export abstract class MatchVideoEmbeddingEvent extends DomainEvent<MatchVideoEmbedding> {}
